import { createContext, useState, useEffect } from "react";
import WindowDimensions from "../../components/windowDimensions";

const TabContext = createContext({
  value: "",
  values: {},
  updateValue: () => {},
});

export function TabContextProvider(props) {
  const [value, setValue] = useState("export");
  const [previousValue, setPreviousValue] = useState("export");
  const { height, width } = WindowDimensions();

  function updateValue(value) {
    setPreviousValue(value);
    setValue(value);
  }

  const values = Object.freeze({
    export: "export",
    import: "import",
    both: "both",
  });

  useEffect(() => {
    if (width >= 1700) {
      if (value === values.export || value === values.import) {
        setPreviousValue(value);
      }
      setValue(values.both);
    } else {
      setValue(previousValue);
    }
  });

  const context = {
    value: value,
    values: values,
    updateValue: updateValue,
  };

  return (
    <TabContext.Provider value={context}>{props.children}</TabContext.Provider>
  );
}

export default TabContext;
